import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { trackDatadogRumError } from 'utils/initDatadogRum';
import { IBackOfEnvelopeResponse, IBackOfEnvelopeQueryParams } from '../types';

const getBackOfEnvelopeDeals = async ({ orgId }: IBackOfEnvelopeQueryParams): Promise<IBackOfEnvelopeResponse> => {
    const { data } = await axiosInstance.get(API_ENDPOINTS.BACK_OF_ENVELOPE_DEALS(orgId));
    if (!Array.isArray(data?.items)) {
        trackDatadogRumError(
            new Error('[useGetBackOfEnvelopeDeals] Expected items array response'),
            { receivedType: typeof data?.items, receivedValue: data },
        );
    }
    return {
        ...data,
        items: Array.isArray(data?.items) ? data.items : [],
    };
};

export const useGetBackOfEnvelopeDeals = ({ orgId, enabled = true }:
     IBackOfEnvelopeQueryParams & { enabled?: boolean }) => useQuery<IBackOfEnvelopeResponse>({
         queryKey: ['back-of-envelope-scenarios', orgId],
         queryFn: () => getBackOfEnvelopeDeals({ orgId }),
         staleTime: 5000,
         enabled,
     });
